import request from '@/utils/request'
const apiPath = '/sys/sysAddr'
const sysAddrApi = {
  /**
   * 新增【系统地址管理】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【系统地址管理】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【系统地址管理】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchTreeList(query) {
    return request.get(apiPath + '/getTreeList', { params: query })
  },
  fetchTreeList2(query) {
    return request.get(apiPath + '/getTreeList2', { params: query })
  },
  /**
   * 查询【系统地址管理】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【系统地址管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【系统地址管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【系统地址管理】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  }
}
export default sysAddrApi
